var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShield = function SvgShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.971,
    height: 34.848,
    viewBox: "0 0 29.971 34.848",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_secure_3549891_000000",
    d: "M38.986,19.539l-1.286.513L26.173,24.663,24,25.535v12.68A12.743,12.743,0,0,0,30.156,49.09L37.2,53.32l1.781,1.067,1.781-1.067,7.049-4.23a12.745,12.745,0,0,0,6.156-10.875V25.535L51.8,24.663,40.271,20.052ZM31.937,46.122a9.219,9.219,0,0,1-4.478-7.907V27.874l9.8-3.92V49.315Zm18.577-7.907a9.22,9.22,0,0,1-4.478,7.907l-5.32,3.193V23.954l9.8,3.92Z",
    transform: "translate(-24 -19.539)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield.2e215ea6.svg";
export { ForwardRef as ReactComponent };